export const NOTICE_AREA = {HEADER: 'HEADER', BODY: 'BODY'};
export const NOTICE_STATUS = {WARNING: 'WARNING', ERROR: 'ERROR', SUCCESS: 'SUCCESS', INFO: 'INFO'};
export const AUTH_PROVIDER = {DEFAULT: 'DEFAULT', GOOGLE: 'GOOGLE', APPLE: 'APPLE'}
export const UNIT_SYSTEM = {METRIC: 'METRIC', IMPERIAL: 'IMPERIAL'}
export const UNIT_TEMPERATURE = {DEGREE_CELSIUS: 'DEGREE_CELSIUS', DEGREE_FAHRENHEIT: 'DEGREE_FAHRENHEIT'}